import { holdAtLocation } from './_updateShipping.js';

export const holdAtLocationRadioClicked = (params, returnHTML) => {
	function myCallback(params) {
		var element = document.getElementById('openCloseHalModal');
		if (element.innerHTML == 'close') {
			var elements = document.getElementsByClassName('close');
			var i;
			for (i = 0; i < elements.length; i++) {
				elements[i].click();
			}
		}
		if (document.getElementById('locationSelection_0') === null) {
		} else {
			document.getElementById('locationSelection_0').click(); //select first location
		}
		$('#selectLocationBtn').on('click', function () {
			var pickupFirstName = $('#shippingMethodForm input[name="pickupFirstName"]').val(),
				pickupLastName = $('#shippingMethodForm input[name="pickupLastName"]').val(),
				firstNameOverride = $('#pickupFirstNameOverride').val(),
				lastNameOverride = $('#pickupLastNameOverride').val(),
				setFedexLocation = '';
			if (pickupFirstName == '' && pickupLastName == '' && firstNameOverride == '' && lastNameOverride == '') {
				setFedexLocation = $('.locations input:checked').parents('ul.locations').data('json');
				$('#address-checkout-hal').attr('data-location', JSON.stringify(setFedexLocation));
				$('#holdAtLocationInputs').hide();
				$('li#holdAtLocationStoreName').text(setFedexLocation.pickupStoreName);
				$('li#holdAtLocationAddress').text(setFedexLocation.address1);
				$('li#holdAtLocationCityStateZip span#halCity').text(setFedexLocation.city);
				$('li#holdAtLocationCityStateZip span#halState').text(setFedexLocation.state);
				$('li#holdAtLocationCityStateZip span#halZip').text(setFedexLocation.zipCode);
				$('#address-checkout-hal').show();
				$('#holdAtLocationPickupPerson').show();
				$('#holdAtLocationPickupNames').show();
				$('#shippingMethodWrapper').hide();
				$('#giftWrapWrapper').hide();
				$('.card-footer').hide();
			} else if (firstNameOverride != '' && lastNameOverride != '') {
				setFedexLocation = $('.locations input:checked').parents('ul.locations').data('json');
				$('#shippingMethodForm input[name="pickupFirstName"]').val(firstNameOverride);
				$('#shippingMethodForm input[name="pickupLastName"]').val(lastNameOverride);
				$('#holdAtLocationPickupPerson').show();
				$('#holdAtLocationPickupNameDisplay').show();
				$('#holdAtLocationPickupNames').hide();
				$('#halOptInText').show();

				holdAtLocation(document.shippingMethodForm, setFedexLocation);
				$('#shippingMethodWrapper').show();
				$('#giftWrapWrapper').show();
				$('.card-footer').show();
			}
		});
		$('#updateHalName').on('click', function () {
			$('#holdAtLocationPickupNames').show();
			$(this).hide();
		});

		// $('#select#locationsRadius').on("change", function() {
		//   var selectedDistance = $(this).children('option:selected').val();
		//     callHoldAtLocation(selectedDistance);
		//   });

		$('#holdAtLocationSearch').on('click', function () {
			var selectedDistance = $('select#locationsRadius').children('option:selected').val();
			var zipModal = $('input#holdAtLocationModalZip').val();
			document.getElementById('openCloseHalModal').innerHTML = 'open';
			callHoldAtLocation(selectedDistance, zipModal);
		});
	}

	function callHoldAtLocation(selectedDistance, zipCode) {
		$.ajax({
			url: '/webapp/wcs/stores/servlet/HoldAtLocationLookup?storeId=301&catalogId=301&langId=-1&distance=' + selectedDistance + '&zipCode=' + zipCode,
			cache: false,
			type: 'GET',
			success: function (json) {
				if (json.JSONError) {
					returnHTML(
						'<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="alert alert-danger" role="alert">FedEx services are currently unavailable. Please choose a different shipping address or try again later.</div></div>',
						myCallback
					);
				} else {
					var responseJSON = json.JSON;
					var locationArr = [];
					if (responseJSON.length == 0) {
						locationArr.push(
							`<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<div class="alert alert-danger" role="alert">No locations found in your area.</div>
							</div>`
						);
					} else {
						for (var i = 0; i < responseJSON.length; i++) {
							locationArr.push(
								`<ul class="locations d-flex justify-content-between" data-json='${JSON.stringify(responseJSON[i])}'>
									<li class="radioOpt flex-fill">
										<div class="custom-control custom-radio custom-control-inline">
											<input type="radio"  name="fedex-location-radio" id="locationSelection_${i}" class="custom-control-input">
											<label class="custom-control-label"  for="locationSelection_${i}" name="fedex-location-radio" id="locationSelection_${i}">
												<span class="location-name">${responseJSON[i].pickupStoreName}</span>
											</label>
										</div>
									</li>
									<li class="location-address flex-fill">
									<span class="label">Address:</span>
										<span class="address">${responseJSON[i].address1}</span>
										<span class="address">${responseJSON[i].city}, ${responseJSON[i].state} ${responseJSON[i].zipCode}</span>
									</li>
									<li class="location-hours flex-fill">
										<span class="label">Location Hours:</span>
										<ul>
											${responseJSON[i].hours.length ? responseJSON[i].hours.map((test) => `<li class="hours">${test.dayOfWeek}: <span>${test.open}</span></li>`).join(' ') : ''}
										</ul>
									</li>
								</ul>`
							);
						}
					}

					var holdLocationHTML = `<div id="locationDistance">
							<div id="holdAtLocationInputsModal" class="form-inline">
								<div class="form-group">
									<label for="holdAtLocationLookupZip" class="label sr-only">Zip/Postal Code:</label>
									<input class="form-control m-r-10" type="tel" data-mask="00000" maxlength="5" id="holdAtLocationModalZip" placeholder="Zip Code" value="${zipCode}"/>
									<div class="locationsDistanceRadius">
										<label for="locationsRadius" class="sr-only">Distance</label>
										<select id="locationsRadius" class="form-control m-r-10">
											<option value="5" ${5 == selectedDistance ? 'selected' : ''}>5 mile radius</option>
											<option value="10" ${10 == selectedDistance ? 'selected' : ''}>10 mile radius</option>
											<option value="25" ${25 == selectedDistance ? 'selected' : ''}>25 mile radius</option>
											<option value="50" ${50 == selectedDistance ? 'selected' : ''}>50 mile radius</option>
											<option value="100" ${100 == selectedDistance ? 'selected' : ''}>100 mile radius</option>
										</select>
									</div>
									<button class="btn-secondary btn btn-sm" id="holdAtLocationSearch" type="button">Search</button>
								</div>
							</div>
						</div>
						<div class="location-wrapper">
							${locationArr.join(' ')}
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-modal-title="cancel" data-dismiss="modal" aria-label="Cancel">Cancel</button>`;
					if (responseJSON.length > 0) {
						holdLocationHTML += `<button type="button" class="btn btn-primary" id="selectLocationBtn" data-dismiss="modal">Select This Location</button>`;
					}
					holdLocationHTML += `</div>`; //close modal-footer
					returnHTML(holdLocationHTML, myCallback);
					//$('.location-wrapper .locations:first-child input').prop('checked', true); //select first location
				}
			},
			error: function (json) {
				returnHTML(
					'<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="alert alert-danger" role="alert">FedEx services are currently unavailable. Please choose a different shipping address or try again later.</div></div>',
					myCallback
				);
			},
		});
	}
	var defaultZipCode = $('#holdAtLocationLookupZip').val();
	document.getElementById('openCloseHalModal').innerHTML = 'close';
	callHoldAtLocation(25, defaultZipCode);
};
